import i18n from '@/utils/i18n'

export const status = {
  UNFINISHED_ONLINE_BOOKING: 0,
  DRAFT_OFFLINE_BOOKING: 4,
  UNFINISHED_OFFLINE_BOOKING: 5,
  WAITING_FOR_MANAGER_PRE_VALIDATION: 10,
  SUBMITTED_REQUEST: 20,
  DENIED_REQUEST: 30,
  BEING_PROCESSED: 40,
  WAITING_FOR_MANAGER_POST_VALIDATION: 45,
  WAITING_FOR_CUSTOMER_CONFIRMATION: 50,
  WAITING_FOR_ORDER_NUMBER: 55,
  CONFIRMED: 60,
  CHANGE_REQUEST: 65,
  CANCEL_REQUEST: 70,
  CANCELLED: 80,
  FINISHED: 90
}

export function getStatusTranslation (status, isManager) {
  let base = 'booking.status.'
  let defaultKey = 'default'
  let key = isManager ? 'manager' : defaultKey
  let translationKey = base + status + '.' + key
  let translationDefaultKey = base + status + '.' + defaultKey

  if (i18n.te(translationKey)) {
    return i18n.t(translationKey)
  } else {
    return i18n.t(translationDefaultKey)
  }
}
